/* Noveza — carrousels, onglets « univers » et « sélection » de l'accueil */
(function () {
  function rowOf(btn) {
    var box = btn.closest('[data-tk-univers], [data-tk-selection], [data-tk-related]');
    if (!box) return null;
    var rows = box.querySelectorAll('[data-tk-row]');
    for (var i = 0; i < rows.length; i++) if (!rows[i].hidden) return rows[i];
    return rows[0] || null;
  }

  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('.tk-arrow');
    if (arrow) {
      var row = rowOf(arrow);
      if (row) row.scrollBy({ left: parseInt(arrow.getAttribute('data-dir'), 10) * row.clientWidth * 0.8, behavior: 'smooth' });
      return;
    }
    var chip = e.target.closest('.tk-chip');
    if (chip) {
      var box = chip.closest('[data-tk-univers]');
      var g = chip.getAttribute('data-g');
      [].forEach.call(box.querySelectorAll('.tk-chip'), function (c) { c.classList.toggle('is-on', c === chip); });
      [].forEach.call(box.querySelectorAll('.tk-tile'), function (t) { t.hidden = !!g && t.getAttribute('data-g') !== g; });
      var r = box.querySelector('[data-tk-row]');
      if (r) r.scrollTo({ left: 0 });
      return;
    }
    var tab = e.target.closest('.tk-tab');
    if (tab) {
      var sel = tab.closest('[data-tk-selection]');
      var i = tab.getAttribute('data-i');
      [].forEach.call(sel.querySelectorAll('.tk-tab'), function (t) { t.classList.toggle('is-on', t === tab); });
      [].forEach.call(sel.querySelectorAll('[data-tk-row]'), function (r2) { r2.hidden = r2.getAttribute('data-i') !== i; });
    }
  });
})();

/* en-tete : apres un peu de defilement, seule la ligne logo + recherche reste (menu et bandeau se replient, comme chez Tikamoon) */
(function () {
  function update(e) {
    var y = window.scrollY || 0;
    var t = e && e.target;
    if (t && t.scrollTop) y = Math.max(y, t.scrollTop);
    document.documentElement.classList.toggle('tk-scrolled', y > 60);
  }
  document.addEventListener('scroll', update, { capture: true, passive: true });
  update();
})();

/* les carrousels démarrent toujours au premier élément */
window.addEventListener('load', function () {
  [].forEach.call(document.querySelectorAll('[data-tk-row]'), function (r) { r.scrollLeft = 0; });
});

/* bande d'atouts : defilement automatique sur toute la largeur (boucle continue) */
(function () {
  var strips = document.querySelectorAll('.tk-strip--line .tk-strip__list');
  [].forEach.call(strips, function (ul) {
    var items = [].slice.call(ul.children);
    if (!items.length) return;
    var track = document.createElement('div');
    track.className = 'tk-marquee__track';
    var a = document.createElement('ul'); a.className = 'tk-marquee__set';
    items.forEach(function (li) { a.appendChild(li); });
    var b = a.cloneNode(true); b.setAttribute('aria-hidden', 'true');
    /* assez de copies pour couvrir les grands ecrans */
    track.appendChild(a); track.appendChild(b);
    ul.parentNode.classList.add('is-marquee');
    ul.parentNode.replaceChild(track, ul);
  });
})();

/* « Les produits les plus recherches » (mobile) : 3 lignes qui defilent automatiquement, en sens alterne */
(function () {
  var ul = document.querySelector('.mbtb-links');
  if (!ul || !window.matchMedia('(max-width: 999px)').matches) return;
  var items = [].slice.call(ul.children);
  if (items.length < 4) return;
  var rows = 3, per = Math.ceil(items.length / rows);
  var wrap = document.createElement('div');
  wrap.className = 'tk-chiprows';
  for (var r = 0; r < rows; r++) {
    var part = items.slice(r * per, (r + 1) * per);
    if (!part.length) continue;
    var row = document.createElement('div'); row.className = 'tk-chiprow';
    var track = document.createElement('div'); track.className = 'tk-chiprow__track';
    track.style.animationDuration = (26 + r * 6) + 's';
    if (r % 2 === 1) track.style.animationDirection = 'reverse';
    var a = document.createElement('ul'); a.className = 'tk-chiprow__set';
    part.forEach(function (li) { a.appendChild(li); });
    var b = a.cloneNode(true); b.setAttribute('aria-hidden', 'true');
    track.appendChild(a); track.appendChild(b); row.appendChild(track); wrap.appendChild(row);
  }
  ul.parentNode.replaceChild(wrap, ul);
})();

/* pied de page : colonnes toujours ouvertes sur ordinateur, repliables sur mobile */
(function () {
  var cols = document.querySelectorAll('.tk-ft__col');
  if (!cols.length) return;
  var mq = window.matchMedia('(min-width: 1000px)');
  function sync() { if (mq.matches) [].forEach.call(cols, function (d) { d.open = true; }); }
  sync();
  if (mq.addEventListener) mq.addEventListener('change', sync); else if (mq.addListener) mq.addListener(sync);
  [].forEach.call(cols, function (d) { d.querySelector('summary').addEventListener('click', function (e) { if (mq.matches) e.preventDefault(); }); });
})();
